var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 8L15 10h-5M11.5 14L10 12h5",
    stroke: "#7D8085",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3 1.9A1.4 1.4 0 00.9 3.3v9.4a1.4 1.4 0 001.4 1.4h6.2v-1.2H2.3a.2.2 0 01-.2-.2V3.864l4.876 4.063a1.6 1.6 0 002.048 0L13.9 3.864V6.9h1.2V3.3a1.4 1.4 0 00-1.4-1.4H2.3zm10.643 1.2H3.057l4.687 3.905a.4.4 0 00.512 0L12.943 3.1z",
    fill: "#7D8085"
  })));
}
export default __webpack_public_path__ + "static/mail-exchange.5a1e795a.svg";
export { SvgMailExchange as ReactComponent };